import axios from 'axios';

const noteApi = axios.create({
    baseURL: process.env.REACT_APP_NOTE_API_URL
});

export default noteApi;